export default __webpack_public_path__ + "static/media/IMG-20210711-WA0008.1e191a11.jpg";